module.exports = __webpack_public_path__ + "static/media/sphere.f4fa713c.jpeg";